import { editUserAction } from 'redux/actions/usersActions';
import { generateSimpleRequestReducer } from 'redux/utils/requestWithoutData';

export default generateSimpleRequestReducer(editUserAction);
